import React from 'react'
import TabLinkUI from '../../../widgets/output/TabLinkUI'

const UseOfProceedsNavUI = ({ loan, page }) =>
  <div>
    <div className='g_flex_h g_flex_left g_flex_wrap'>
      <TabLinkUI label='Draft' to={`/su/loans/${loan.loanId}/proceeds/draft`} active={page === 'proceedsdraft'} />
      <TabLinkUI label='Final' to={`/su/loans/${loan.loanId}/proceeds`} active={page === 'proceeds'} />
    </div>
    <div className='g_m_top_50' />
  </div>

export default UseOfProceedsNavUI
